import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const WelcomeScreen = () => {
  const { t } = useTranslation()
  const theme = useTheme()

  return (
    <Styles.Layout>
      <Styles.Card>
        <Styles.IconsContainer>
          <Styles.IconsTrack>
            <Styles.IconsStrip src="/images/welcome-icons.svg" alt="" />
            <Styles.IconsStrip src="/images/welcome-icons.svg" alt="" />
          </Styles.IconsTrack>
        </Styles.IconsContainer>
        <Styles.Content>
          <Styles.Title>
            <Text tag="h1" customStyles={theme.texts.titleXXL} color={theme.colors.text.default}>
              {t('Bienvenido a Reveni')}
            </Text>
            <Text customStyles={theme.texts.allCapsL} color={theme.colors.text.subtle}>
              {t('Ya casi estás. Un último paso')}
            </Text>
          </Styles.Title>
          <Text customStyles={theme.texts.bodyMRegular} color={theme.colors.text.default}>
            {t(
              'Para empezar a usar Reveni y disfrutar de todas sus funcionalidades, nuestro equipo tiene que activar tu cuenta. Nos pondremos en contacto contigo en breve. Gracias por tu paciencia.'
            )}
          </Text>
          <Styles.WebsiteLink href="https://reveni.com" target="_blank" rel="noreferrer">
            {t('Ir a reveni.com')}
          </Styles.WebsiteLink>
        </Styles.Content>
      </Styles.Card>
    </Styles.Layout>
  )
}

export default WelcomeScreen
